import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { EyeIcon } from '@heroicons/react/24/outline'
import { PreviewEmptyStateWrapper } from '../../jiraWizard.styles'

interface Props {
  title: string
  description: string
}

const PreviewEmptyState: FC<Props> = ({ title, description }) => (
  <PreviewEmptyStateWrapper>
    <Box className="empty-state-icon">
      <EyeIcon width={48} height={48} />
    </Box>

    <Box className="empty-state-text">
      <Typography className="empty-state-title">{title}</Typography>
      <Typography className="empty-state-description">{description}</Typography>
    </Box>
  </PreviewEmptyStateWrapper>
)

export default PreviewEmptyState
